export default "__VITE_ASSET__CMrOIZg0__"